import loading from "@/components/loading/loading"; // loading组件
import commonDialog from "@/components/commonDialog/commonDialog";
import commonDialog2 from "@/components/commonDialog2/commonDialog2";
export default (Vue) => {
  Vue.component("loading", loading);
  Vue.component("commonDialog", commonDialog);
  Vue.component("commonDialog2", commonDialog2);
};
